module.exports = __webpack_public_path__ + "static/media/gonerdify.net_University.2b26e0fa.png";